import {DOCUMENT} from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
} from '@angular/core';
import {Router} from '@angular/router';
import {InConfiguration} from "../../models/config.interface";
import {AuthService} from "../../auth.service";
import {ConfigService} from "../../services/config.service";
import {UnsubscribeOnDestroyAdapter} from "../../shared/UnsubscribeOnDestroyAdapter";
import {LoadingService} from "../../services/loading.service";
import {NotificationService, NotificationModel} from "../../services/notification.service";
import {Observable} from 'rxjs';
import {NotificationViewComponent} from "../../components/notification-view/notification-view.component";
import {MatDialog} from "@angular/material/dialog";
import {AccountComponent} from "../../components/account/account.component";

@Component({
  selector: 'app-header2',
  templateUrl: './header2.component.html',
  styleUrls: ['./header2.component.scss']
})
export class Header2Component
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit {
  public config!: InConfiguration;
  isLoading: boolean = true;
  isNavbarCollapsed = false;
  isNavbarShow = true;
  userData = JSON.parse(localStorage.getItem('userData') || '{}');
  isOpenSidebar?: boolean;
  docElement: HTMLElement | undefined;
  isFullScreen = false;
  navbarColor = 'white';
  notifications$: Observable<NotificationModel[]>;
  unreadCount = 0;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private dialog : MatDialog
  ) {
    super();
    this.notifications$ = this.notificationService.getUserNotifications(this.userData.email);
    this.subs.sink = this.notifications$.subscribe(notifications => {
      this.unreadCount = notifications.filter(n => n.status === 'msg-unread').length;
    });
  }

  listLang = [
    {text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en'},
    {text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es'},
    {text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de'},
  ];

  ngOnInit(): void {
    this.config = this.configService.configData;
    this.configService.navbarColor = this.navbarColor
    const langStoreValue = localStorage.getItem('lang') as string;
    const val = this.listLang.filter((x) => x.lang === langStoreValue);
    // this.countryName = val.map((element) => element.text);
    // if (val.length === 0) {
    //     if (this.flagvalue === undefined) {
    //         this.defaultFlag = 'assets/images/flags/us.jpg';
    //     }
    // } else {
    //     this.flagvalue = val.map((element) => element.flag);
    // }
    // Subscribe to the loading state from the service
    this.subs.sink = this.loadingService.loading$.subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
    this.createSampleNotifications();
  }
  openAccount(){
    this.dialog.open(AccountComponent, {
      width: '800px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '85vh',
      panelClass: 'account-dialog',
      autoFocus: false
    });
  }
  ngAfterViewInit(): void {
    // set theme on startup
    if (localStorage.getItem('theme')) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('theme') as string
      );
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem('menuOption')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('menuOption') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'menu_' + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem('choose_logoheader')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('choose_logoheader') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'logo-' + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem('sidebar_status')) {
      if (localStorage.getItem('sidebar_status') === 'close') {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      } else {
        this.renderer.removeClass(this.document.body, 'side-closed');
        this.renderer.removeClass(this.document.body, 'submenu-closed');
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    }
  }

  callFullscreen(): void {
    const elem = this.docElement || document.documentElement;

    if (!this.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if ((elem as any).webkitRequestFullscreen) {
        (elem as any).webkitRequestFullscreen(); // Safari
      } else if ((elem as any).msRequestFullscreen) {
        (elem as any).msRequestFullscreen(); // IE11
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen(); // Safari
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen(); // IE11
      }
    }

    this.isFullScreen = !this.isFullScreen;
  }

  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }

  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  logout() {
    this.authService.SignOut()
      .then(res => {
        localStorage.removeItem('user');
        this.authService.roleAs = '';

        this.router.navigate(['login']);
        console.log('Logged out!');
      })


  }

  async markAsRead(notificationId: string, event: Event) {
    event.stopPropagation();
    await this.notificationService.markAsRead(notificationId);
    // this.refreshNotifications();
  }

  async markAllAsRead() {
    await this.notificationService.markAllAsRead(this.userData.email);
    // this.refreshNotifications();
  }

  // viewAllAlerts() {
  //   this.router.navigate(['/home/notifications']);
  //   this.markAllAsRead();
  // }
  viewAllAlerts() {
    const dialogRef = this.dialog.open(NotificationViewComponent, {
      width: '900px',
      height: '700px',
    });
  }


  async deleteNotification(notificationId: string, event: Event) {
    event.stopPropagation();
    await this.notificationService.deleteNotification(notificationId);
  }

  handleNotificationClick(notification: NotificationModel) {
    if (notification.status === 'msg-unread') {
      this.markAsRead(notification.id, new Event('click'));
    }
    if (notification.link) {
      this.router.navigate([notification.link]);
    }
  }

  getTimeAgo(firestoreDate: any): string {
    if (!firestoreDate) return '';

    // Convert Firestore timestamp to JS Date
    const date = firestoreDate.toDate ? firestoreDate.toDate() : firestoreDate;

    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} days ago`;
    if (hours > 0) return `${hours} hours ago`;
    if (minutes > 0) return `${minutes} mins ago`;
    return 'Just now';
  }


  async createSampleNotifications() {
    const sampleNotifications = [
      {
        email: 'test1@gmail.com',
        message: 'New user registration request',
        time: new Date(),
        icon: 'person_add',
        color: '#4CAF50',
        status: 'msg-unread' as const,
        type: 'registration',
        link: '/users/pending'
      },
      {
        email: 'test1@gmail.com',
        message: 'New complaint reported',
        time: new Date(Date.now() - 3600000), // 1 hour ago
        icon: 'report_problem',
        color: '#ff9800',
        status: 'msg-unread' as const,
        type: 'complaint',
        link: '/complaints'
      },
      {
        email: 'test1@gmail.com',
        message: 'System maintenance scheduled',
        time: new Date(Date.now() - 86400000), // 1 day ago
        icon: 'build',
        color: '#2196F3',
        status: 'msg-read' as const,
        type: 'system'
      },
      {
        email: 'test1@gmail.com',
        message: 'Monthly report available',
        time: new Date(Date.now() - 172800000), // 2 days ago
        icon: 'assessment',
        color: '#673AB7',
        status: 'msg-read' as const,
        type: 'report',
        link: '/reports'
      }
    ];

    //     try {
    //         for (const notification of sampleNotifications) {
    //             await this.notificationService.createNotification(notification);
    //             console.log('Created notification:', notification.message);
    //         }
    //         console.log('All sample notifications created successfully');
    //     } catch (error) {
    //         console.error('Error creating notifications:', error);
    //     }
  }

}
